import {
  GetCardDetails,
  GetTransactionDetails,
  GetShippingDetails,
  // GetBillingDetails,
  TransactionRequest,
  ThreeDS,
} from "./BacFunctions";

const preProcess = async ({
  shippingDetails,
  MerchantInfo,
  orderNumber,
  ResponseURL,
  total,
  // totalUSD,
}) => {
  let format;
  let amount = total;
  // shippingDetails.currencySelect.currency.currency === "HNL" ||
  // shippingDetails.currencySelect.currency === ""
  //   ? total
  //   : totalUSD;
  let currency = "340";
  // shippingDetails.currencySelect.currency.currency === "HNL" ||
  // shippingDetails.currencySelect.currency === ""
  //   ? "340"
  //   : "740";

  let request = {
    CardDetails: GetCardDetails(shippingDetails),
    TransactionDetails: await GetTransactionDetails(
      MerchantInfo.MERCH_ID,
      MerchantInfo.MERCH_PWD,
      MerchantInfo.ACQUIRED_ID,
      orderNumber,
      amount,
      currency
    ),
    ShippingDetails: GetShippingDetails(shippingDetails),
    // BillingDetails: GetBillingDetails(shippingDetails),
    RecurringDetails: null,
    FraudDetails: null,
    ThreeDSecureDetails: null,
  };

  if (shippingDetails.cardInfo.cardNumber.value[0] === "3") {
    format = TransactionRequest(request);
  } else {
    format = ThreeDS(request, ResponseURL);
  }
  return format;
};

export { preProcess };
